import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "../../../components/Container";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { INoteRecord } from "../../../lib/types";
import pb from "../../../lib/pocketbase";
import Markdown, { MarkdownStyle } from "../../../components/markdown/Markdown";
import BackButton from "../../../components/form/BackButton";
import Button from "../../../components/form/button";
import { config } from "../../../config";
import { createSlug } from "../../../lib/utils";
import { useToast } from "../../../components/ui/use-toast";
import Loading from "../../../components/Loading";

export default function Note() {
    const noteId = useParams().note;
    const navigate = useNavigate();
    const { toast } = useToast();
    const [isLoading, setIsLoading] = useState(true);
    const [note, setNote] = useState<INoteRecord>();

    function copyUrl() {
        const slug = createSlug(note?.name || "");
        navigator.clipboard?.writeText(`${config.base}/note/${slug}/${note?.id}`);
        toast({
            title: "🤩 Successfully copied url!",
            description: "You have successfully copied the url of this note."
        });
    }

    async function load() {
        setIsLoading(true);
        if (!noteId) {
            navigate("/404");
            return;
        }
        const n: INoteRecord = await pb.collection("note").getOne(noteId, {
            expand: "folder"
        });
        setNote(n);
        setIsLoading(false);
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Note</title>
            </Helmet>
            <Container variant={"small"} className="my-8 lg:my-16">
                <MarkdownStyle className="mx-auto max-w-full">
                    <div className="flex items-center gap-4">
                        <BackButton size={"box"} onClick={() => navigate(`/studio/notes/${note?.expand?.folder?.id ? note?.expand?.folder?.id : ""}`)} />
                        <h1 className="!my-0 flex-grow">
                            {note?.name}{" "}
                            {note?.public && (
                                <Button onClick={copyUrl} variant={"ghost"} size={"ghost"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15" />
                                    </svg>
                                </Button>
                            )}
                        </h1>
                        <Link to="edit" className="!no-underline">
                            <Button>Edit</Button>
                        </Link>
                    </div>
                </MarkdownStyle>

                {isLoading && (
                    <div className="flex w-full justify-center">
                        <Loading />
                    </div>
                )}

                <div className="mt-8">
                    <Markdown className="mx-auto max-w-full">{note?.content || ""}</Markdown>
                </div>
            </Container>
        </>
    );
}
